import React from "react";
import { Button, Modal } from "react-bootstrap";
import NewsContent, { formatNewsDate, getNewsReleaseDate } from "./newsContent";

const NewsModal = ({ item, show, onHide, onCloseLabel, onReady }) => {
  if (!item) {
    return null;
  }

  const isHtml = item.contentType === "Html";

  return (
    <Modal className={isHtml ? "news-modal news-modal-html" : "news-modal"} show={show} onHide={onHide} centered size={isHtml ? "xl" : "lg"}>
      <Modal.Header closeButton>
        <div>
          <Modal.Title>{item.title}</Modal.Title>
          {item && <div className="news-modal-meta">
            {item.contentType}
            {formatNewsDate(getNewsReleaseDate(item)) ? ` | ${formatNewsDate(getNewsReleaseDate(item))}` : ""}
          </div>}
        </div>
      </Modal.Header>
      <Modal.Body>
        <NewsContent item={item} onReady={onReady} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          {onCloseLabel || "Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewsModal;
